import { uiRows } from './types-def.js';
/**
 * `web/import` (2.B-2; CS r4a deliverable 110): the Notion import wizard, match review, apply,
 * history and the Tidy pill. Every action has a visible control (DECISIONS 161).
 */
export const IMPORT_INTERACTIONS = uiRows([
    {
        id: 'import.entry.open',
        module: 'web/import',
        behavior: '"Import from Notion" in the sidebar and on the Settings page opens the import',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.upload.start',
        module: 'web/import',
        behavior: '"Choose file" or a drop starts the upload with its progress; Cancel stops it and Resume continues it',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.mapping.choose',
        module: 'web/import',
        behavior: 'Each database, property and status option is mapped from its own menu',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.defaults.set',
        module: 'web/import',
        behavior: 'The defaults for title matches and pages changed in both places are chosen',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.dryrun.run',
        module: 'web/import',
        behavior: '"Run dry run" shows the report of what the import would do',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.match.choose',
        module: 'web/import',
        behavior: "A match's segmented choice, the filters, Apply to selected and Compare decide each page",
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.apply.run',
        module: 'web/import',
        behavior: '"Import" applies with progress and Cancel, then links to the Inbox and the catalogue',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.history.undo',
        module: 'web/import',
        behavior: 'Import history offers Import again and Undo import, listing the refused pages',
        owner: '2.B-2',
        since: 'exit-2a',
    },
    {
        id: 'import.tidy.open',
        module: 'web/import',
        behavior: 'The "Review tidy suggestions" pill opens the Tidy panel for an imported page',
        owner: '2.B-2',
        since: 'exit-2a',
    },
]);
//# sourceMappingURL=import.js.map